module.exports = __webpack_public_path__ + "img/once_fr.88d8d14a.png";